import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('author-request-pool-list',_vm._g({staticClass:"px-0",attrs:{"requests":_vm.requests,"loading":_vm.loading,"updating":_vm.updating}},_vm.$listeners)),_c('assignment-comments',{attrs:{"assignment-id":_vm.showCommentsForAssignmentId},on:{"close":_vm.hideComments,"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }